/** Admin chart ids + Chart PNG registry ids for Statewide Analysis (must match adminPageConfig). */
export const PUBLICATION_ANALYSIS_CHART_IDS = {
  ghgStacked: 'pub_ca_ghg_stacked',
  vsCarb: 'pub_ca_vs_carb',
  spatialMap: 'pub_spatial_ghg_map',
  rankings: 'pub_ghg_rankings',
  abatementScatter: 'pub_abatement_scatter',
} as const;

export const PUBLICATION_ANALYSIS_SECTION_ID = 'figures' as const;
